import { colorTableOperationIcon } from '@atlas-frontend/design-tokens';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { CellContext } from '@tanstack/react-table';
import { ButtonProps } from 'antd';
import React from 'react';
import * as Icon from 'react-feather';
import { TableOperationButton } from '../TableOperationButton';
import translations from './DetailsTableRowButton.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'details-table-row-button',
);
addTranslations(translations);

export interface DetailsTableRowButtonProps
  extends Omit<ButtonProps, 'id' | 'title'> {
  id?: string;
  context: CellContext<any, any>;
  detailsTitle?: string;
  emptyTitle?: string;
  hasDetails?: boolean;
}

export const DetailsTableRowButton = (props: DetailsTableRowButtonProps) => {
  const { t } = useTranslation();
  const {
    hasDetails = false,
    detailsTitle = t('button.details'),
    emptyTitle = t('button.no-details'),
    onClick,
    context,
    id = `details-table-row-${context.row.index}`,
    href,
    ...rest
  } = props;

  const title = t(hasDetails ? detailsTitle : emptyTitle);
  return (
    <TableOperationButton
      {...rest}
      id={id}
      title={title}
      icon={
        hasDetails ? (
          <Icon.Eye size={18} color={colorTableOperationIcon} />
        ) : (
          <Icon.EyeOff size={18} color={colorTableOperationIcon} />
        )
      }
      href={hasDetails ? href : undefined}
      onClick={hasDetails ? onClick : undefined}
      disabled={!hasDetails}
      type="text"
      aria-label={title}
    />
  );
};
